var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearchInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1402",
    transform: "translate(-167 -3654)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167 3654)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 3668h228a8 8 0 0 1 8 8v16H179v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 3668.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V3676a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(189 3677)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(197 3677)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(205 3677)",
    fill: "#00c243"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179 3691h244v20H179z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M179.5 3691.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(189 3696)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(349 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(365 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(381 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(397 3699)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1611",
    fill: "#c7cbd1",
    d: "M179 3711h244v78H179z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1613",
    fill: "#fff",
    d: "M189 3789h225v115H189z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1393",
    transform: "translate(-158 1511)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1507",
    width: 202,
    height: 4,
    rx: 1,
    transform: "translate(358 2314)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1509",
    width: 202,
    height: 4,
    rx: 1,
    transform: "translate(358 2323)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1510",
    width: 198,
    height: 4,
    rx: 1,
    transform: "translate(358 2332)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1615",
    width: 144,
    height: 4,
    rx: 1,
    transform: "translate(358 2341)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1398",
    transform: "translate(-10)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 23",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(209 3769)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1397",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1616",
    width: 44,
    height: 4,
    rx: 1,
    transform: "translate(226 3771)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1617",
    width: 26,
    height: 2,
    rx: 1,
    transform: "translate(226 3777)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1399",
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1612",
    width: 204,
    height: 9,
    rx: 1,
    transform: "translate(200 3801)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1619",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(200 3793)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1401"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 169",
    d: "M282.5 3871h47.964c2.484 0 4.5 1.343 4.5 3v10c0 1.657-2.013 3-4.5 3H282.5c-2.487 0-4.5-1.343-4.5-3v-10c0-1.657 2.013-3 4.5-3Z",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 183",
    d: "M286.264 3880.1a1.279 1.279 0 0 0 .112.56 1.011 1.011 0 0 0 .312.38 1.33 1.33 0 0 0 .46.216 2.224 2.224 0 0 0 .564.068 1.811 1.811 0 0 0 .56-.076 1.133 1.133 0 0 0 .376-.2.708.708 0 0 0 .208-.276.826.826 0 0 0 .064-.316.683.683 0 0 0-.148-.484.845.845 0 0 0-.324-.22 6.775 6.775 0 0 0-.708-.212q-.4-.1-1-.26a2.135 2.135 0 0 1-.612-.252 1.46 1.46 0 0 1-.384-.348 1.222 1.222 0 0 1-.2-.408 1.636 1.636 0 0 1-.06-.44 1.486 1.486 0 0 1 .18-.748 1.6 1.6 0 0 1 .476-.524 2.093 2.093 0 0 1 .672-.308 2.945 2.945 0 0 1 .76-.1 2.989 2.989 0 0 1 .844.116 2.081 2.081 0 0 1 .7.348 1.7 1.7 0 0 1 .476.572 1.691 1.691 0 0 1 .176.788h-1a.964.964 0 0 0-.376-.78 1.493 1.493 0 0 0-.856-.228 1.872 1.872 0 0 0-.368.032 1.144 1.144 0 0 0-.336.12.737.737 0 0 0-.252.228.616.616 0 0 0-.1.36.613.613 0 0 0 .188.476 1.217 1.217 0 0 0 .492.26l.252.068.492.132.532.14q.26.068.372.1a1.667 1.667 0 0 1 .488.24 1.539 1.539 0 0 1 .348.348 1.437 1.437 0 0 1 .208.42 1.535 1.535 0 0 1 .068.448 1.616 1.616 0 0 1-.2.82 1.664 1.664 0 0 1-.516.556 2.243 2.243 0 0 1-.724.32 3.482 3.482 0 0 1-.832.1 3.424 3.424 0 0 1-.92-.12 2.153 2.153 0 0 1-.752-.368 1.8 1.8 0 0 1-.512-.636 2.117 2.117 0 0 1-.2-.916Zm4.016-2.236h.688v-1.24h.912v1.24h.82v.68h-.82v2.208a2.2 2.2 0 0 0 .012.248.428.428 0 0 0 .056.176.268.268 0 0 0 .132.108.65.65 0 0 0 .24.036h.192a.954.954 0 0 0 .188-.032v.7l-.3.032a2.679 2.679 0 0 1-.3.016 2.019 2.019 0 0 1-.58-.068.774.774 0 0 1-.344-.2.69.69 0 0 1-.156-.328 2.5 2.5 0 0 1-.052-.456v-2.44h-.688Zm6.576 3.216a.484.484 0 0 0 .044.24.186.186 0 0 0 .172.072h.1a.6.6 0 0 0 .128-.016v.632q-.048.016-.124.036t-.16.036q-.08.016-.16.024t-.136.008a.879.879 0 0 1-.464-.112.558.558 0 0 1-.24-.392 1.613 1.613 0 0 1-.668.384 2.631 2.631 0 0 1-.764.12 1.873 1.873 0 0 1-.536-.076 1.407 1.407 0 0 1-.448-.224 1.074 1.074 0 0 1-.312-.376 1.158 1.158 0 0 1-.12-.536 1.229 1.229 0 0 1 .14-.624 1.037 1.037 0 0 1 .368-.376 1.662 1.662 0 0 1 .512-.2q.284-.06.572-.092a4.68 4.68 0 0 1 .472-.068 2.215 2.215 0 0 0 .4-.068.606.606 0 0 0 .272-.148.407.407 0 0 0 .1-.3.467.467 0 0 0-.084-.288.564.564 0 0 0-.208-.172.9.9 0 0 0-.276-.08 2.212 2.212 0 0 0-.288-.02 1.146 1.146 0 0 0-.632.16.624.624 0 0 0-.28.5h-.916a1.373 1.373 0 0 1 .192-.664 1.326 1.326 0 0 1 .428-.42 1.751 1.751 0 0 1 .588-.224 3.5 3.5 0 0 1 .672-.064 2.831 2.831 0 0 1 .6.064 1.7 1.7 0 0 1 .532.208 1.152 1.152 0 0 1 .38.372 1.021 1.021 0 0 1 .144.556Zm-.912-1.152a1.107 1.107 0 0 1-.512.164q-.3.028-.608.084a1.949 1.949 0 0 0-.28.068.843.843 0 0 0-.24.12.527.527 0 0 0-.164.2.684.684 0 0 0-.06.3.383.383 0 0 0 .088.256.639.639 0 0 0 .212.164.982.982 0 0 0 .272.084 1.688 1.688 0 0 0 .268.024 1.485 1.485 0 0 0 .328-.04 1.091 1.091 0 0 0 .332-.136.874.874 0 0 0 .26-.244.617.617 0 0 0 .1-.364Zm1.928-2.064h.856v.8h.016a.923.923 0 0 1 .156-.328 1.521 1.521 0 0 1 .28-.292 1.415 1.415 0 0 1 .364-.212 1.09 1.09 0 0 1 .408-.08 1.979 1.979 0 0 1 .22.008l.124.016v.88q-.1-.016-.2-.028a1.644 1.644 0 0 0-.2-.012 1.048 1.048 0 0 0-.436.092 1 1 0 0 0-.356.272 1.333 1.333 0 0 0-.24.444 1.922 1.922 0 0 0-.088.608V3882h-.912Zm2.432 0h.688v-1.24h.908v1.24h.824v.68h-.824v2.208a2.2 2.2 0 0 0 .016.248.428.428 0 0 0 .056.176.268.268 0 0 0 .132.108.649.649 0 0 0 .24.036h.192a.954.954 0 0 0 .192-.028v.7l-.3.032a2.679 2.679 0 0 1-.3.016 2.019 2.019 0 0 1-.58-.068.774.774 0 0 1-.344-.2.69.69 0 0 1-.168-.332 2.5 2.5 0 0 1-.052-.456v-2.44h-.684Zm4.96 0h.68v-.344a1.764 1.764 0 0 1 .1-.636.9.9 0 0 1 .256-.376.843.843 0 0 1 .364-.176 2.025 2.025 0 0 1 .428-.044 2.611 2.611 0 0 1 .64.056v.712a1.305 1.305 0 0 0-.188-.036 2.012 2.012 0 0 0-.236-.012.556.556 0 0 0-.316.088.386.386 0 0 0-.132.344v.424h.776v.68h-.776V3882h-.912v-3.456h-.68Zm4.856 4.248a2.252 2.252 0 0 1-.884-.164 1.885 1.885 0 0 1-.656-.448 1.933 1.933 0 0 1-.408-.688 2.648 2.648 0 0 1-.14-.88 2.623 2.623 0 0 1 .14-.872 1.933 1.933 0 0 1 .408-.688 1.885 1.885 0 0 1 .656-.452 2.252 2.252 0 0 1 .884-.164 2.252 2.252 0 0 1 .88.16 1.885 1.885 0 0 1 .656.452 1.933 1.933 0 0 1 .408.688 2.623 2.623 0 0 1 .14.872 2.648 2.648 0 0 1-.14.88 1.933 1.933 0 0 1-.404.692 1.885 1.885 0 0 1-.66.448 2.252 2.252 0 0 1-.88.164Zm0-.72a1.046 1.046 0 0 0 .528-.128 1.113 1.113 0 0 0 .368-.336 1.466 1.466 0 0 0 .212-.468 2.094 2.094 0 0 0 .068-.532 2.109 2.109 0 0 0-.068-.528 1.415 1.415 0 0 0-.212-.468 1.13 1.13 0 0 0-.368-.332 1.046 1.046 0 0 0-.528-.128 1.046 1.046 0 0 0-.528.128 1.13 1.13 0 0 0-.368.332 1.415 1.415 0 0 0-.212.468 2.109 2.109 0 0 0-.068.528 2.094 2.094 0 0 0 .068.532 1.466 1.466 0 0 0 .212.468 1.113 1.113 0 0 0 .368.336 1.046 1.046 0 0 0 .528.128Zm2.88-3.528h.856v.8h.016a.923.923 0 0 1 .156-.328 1.521 1.521 0 0 1 .28-.292 1.415 1.415 0 0 1 .364-.212 1.09 1.09 0 0 1 .408-.08 1.979 1.979 0 0 1 .22.008l.124.016v.88q-.1-.016-.2-.028a1.644 1.644 0 0 0-.2-.012 1.048 1.048 0 0 0-.436.092 1 1 0 0 0-.356.272 1.333 1.333 0 0 0-.24.444 1.922 1.922 0 0 0-.088.608V3882H313Zm6.48 4.136h-.9v-.576h-.016a1.253 1.253 0 0 1-.5.5 1.357 1.357 0 0 1-.676.188 1.518 1.518 0 0 1-1.18-.4 1.774 1.774 0 0 1-.364-1.22v-2.628h.912v2.536a1.122 1.122 0 0 0 .208.768.758.758 0 0 0 .584.224 1.152 1.152 0 0 0 .48-.088.849.849 0 0 0 .312-.236.905.905 0 0 0 .172-.356 1.843 1.843 0 0 0 .052-.448v-2.4h.912Zm.992-4.136h.864v.576h.024a2.342 2.342 0 0 1 .224-.28 1.222 1.222 0 0 1 .268-.216 1.355 1.355 0 0 1 .34-.14 1.688 1.688 0 0 1 .44-.052 1.5 1.5 0 0 1 .7.168.95.95 0 0 1 .46.52 1.841 1.841 0 0 1 .536-.5 1.445 1.445 0 0 1 .76-.184 1.494 1.494 0 0 1 1.02.32 1.366 1.366 0 0 1 .364 1.072V3882h-.912v-2.416q0-.248-.016-.452a.923.923 0 0 0-.092-.352.523.523 0 0 0-.228-.228.9.9 0 0 0-.416-.08.772.772 0 0 0-.672.288 1.377 1.377 0 0 0-.208.816V3882h-.912v-2.656a1.126 1.126 0 0 0-.156-.652.656.656 0 0 0-.572-.22.837.837 0 0 0-.34.072.847.847 0 0 0-.288.208 1.041 1.041 0 0 0-.2.336 1.277 1.277 0 0 0-.076.456V3882h-.912Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchInsights);
export default __webpack_public_path__ + "static/media/research-insights.fd853ae716e120a8cb772e600f57ce4f.svg";
export { ForwardRef as ReactComponent };